import {
  SET_QFF_DETAILS,
  IS_LOADING,
  IS_SUCCESS,
  SET_RESPONSE_MESSAGE,
  SET_FIELD_ERRORS,
  CLEAR_FIELD_ERROR,
  REDIRECT_PAGE,
} from './actions'

export const DEFAULT_APP_SCHEMA = {
  isLoading: false,
  success: false,
  message: '',
  fieldError: {},
  fieldValues: {},
}

export default function (state = DEFAULT_APP_SCHEMA, action) {
  switch (action.type) {
    case SET_QFF_DETAILS:
      return {
        ...state,
        fieldValues: {
          ...state.fieldValues,
          ...action.payload,
        },
      }
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case IS_SUCCESS:
      return {
        ...state,
        success: action.payload,
      }
    case SET_RESPONSE_MESSAGE:
      return {
        ...state,
        message: action.payload,
      }
    case SET_FIELD_ERRORS:
      return {
        ...state,
        fieldError: action.payload,
      }
    case CLEAR_FIELD_ERROR: {
      if (!state.fieldError[action.payload]) return state
      // Remove action.payload key from fieldError object using spread
      const { fieldError: { [action.payload]: e, ...fieldError } } = state
      return {
        ...state,
        fieldError,
      }
    }
    case REDIRECT_PAGE:
      window.location.href = action.payload
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./containers/QantasFrequentFlyer/reducer.js